import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment/moment';
import { ExpandableText, TextToolTip } from 'components';
import { CustomDeleteModal, PayableStatusEnum } from 'fragments';
import { payableNotesColors } from './constants';
import { Images, PermissionsList, RolePermission, useModal, useSecondaryModal } from 'utils';
import { loadActions } from 'store';
import { PayableNotes } from './payableNotes';

const DELETE_ACTION_TYPE = 'DELETE_PAYABLE_NOTE';

export const PayableNotesCardForLoad = ({ item, load, afterSuccess }) => {
  const dispatch = useDispatch();
  const { open } = useModal({ noPadding: true, noCloseButton: true });
  const { openSecondary, closeSecondary } = useSecondaryModal();

  const formattedDate = item?.createdDate ? moment(item?.createdDate).format('MM/DD/YY') : '';
  const formattedTime = item?.createdDate ? moment(item?.createdDate).format('hh:mm A') : '';

  return (
    <div
      className='payable-notes-card-for-load-wrapper'
      style={
        {
          border: `1px solid ${payableNotesColors?.[item?.urgency]?.borderColor}`,
          backgroundColor: payableNotesColors?.[item?.urgency]?.backgroundColor,
        }
      }
    >
      <div className='payable-notes-card-for-load-info'>
        <div className='align-justify-center' style={{width:'100%', gap: 8 }}>
          <div className='payable-notes-card-for-load-info-img'>
            <img
              src={Images.FileSvg2}
              alt='file'
              style={{ filter: payableNotesColors?.[item?.urgency]?.filter }}
            />
          </div>

          {item?.text &&
            <ExpandableText htmlContent={item?.text} />
          }
        </div>

        <div className='payable-notes-card-for-load-info-date-creator'>
          <TextToolTip
            content={`Date: ${formattedDate} Time: ${formattedTime}`}
            text={<p>Date: <span>{formattedDate}</span> Time: <span>{formattedTime}</span></p>}
            wrapperStyles={{
              width: 'fit-content',
            }}
            textStyles={{
              fontSize: '12px',
            }}
          />

          {item?.creatorName &&
            <TextToolTip
              content={`Created by: ${item?.creatorName}`}
              text={`Created by: ${item?.creatorName}`}
              wrapperStyles={{
                width: 'fit-content',
              }}
              textStyles={{
                fontSize: '12px',
              }}
            />
          }
        </div>
      </div>

      {(RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code])
        && (load?.payable?.status === PayableStatusEnum.PAYABLE || load?.payable?.status === PayableStatusEnum.PENDING_PAYABLE)) &&
        <div className='payable-notes-card-for-load-actions'>
          <button
            className='reset-btn'
            style={{ padding: '4px' }}
            onClick={() => {
              open(
                <PayableNotes
                  item={item}
                  load={load}
                  afterSuccess={afterSuccess}
                />);
            }}
          >
            <img src={Images.edit} alt='edit' />
          </button>

          <button
            className='reset-btn'
            style={{ padding: '4px 5.91px 4px 5px' }}
            onClick={() => openSecondary(
              <CustomDeleteModal
                afterSuccess={() => {
                  closeSecondary();
                  if (afterSuccess) afterSuccess();
                }}
                actionType={DELETE_ACTION_TYPE}
                text='Delete note?'
                info={'Note'}
                closeModal={closeSecondary}
                handleDel={() => dispatch(loadActions.deletePayableNote(load?.id, item?.id))}
              />,
            )}
          >
            <img src={Images.redTrash} alt='delete' />
          </button>
        </div>
      }
    </div>
  );
};

